export default "/common_trail_svg.41f94a1f-c35d78.svg?svgr";